import React from 'react';
import { Icon } from 'semantic-ui-react';

const HeroButton = ({ button }) => {
  const isPrimary = button.variant === 'variant1';
  const href = isPrimary ? button.externalUrl : button.link;

  return (
    <a
      className={`c-hero__btn ${isPrimary ? 'c-hero__btn--primary' : 'c-hero__btn--ghostSolid'}`}
      href={href}
    >
      <span className="c-hero__btnText">{button.text}</span>
      <span className="c-hero__btnIcon" aria-hidden="true">
          <Icon
              name={button.icon || 'arrow right'}
              size="large"
          />
      </span>
    </a>
  );
};

export default HeroButton;